var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4537 0H23.0399V3.72436L30.96 3.72393L21.3146 13.3693C21.1128 13.5715 20.8396 13.685 20.5543 13.685C20.269 13.685 19.9953 13.5715 19.7936 13.3693L16.5538 10.1296C15.6381 9.21515 14.3968 8.70164 13.1026 8.70164C11.8085 8.70164 10.5677 9.21512 9.6515 10.1296L0 19.7876L2.6315 22.4191L12.2895 12.7611C12.7407 12.3108 13.4711 12.3108 13.9222 12.7611L17.162 16.0008V16.0013C18.0625 16.8992 19.2822 17.4031 20.5541 17.4031C21.8258 17.4031 23.0454 16.8992 23.946 16.0013L33.5914 6.35586V14.2755H37.3158V1.86174C37.3158 1.36817 37.1196 0.894502 36.7702 0.545098C36.4213 0.196138 35.9476 0 35.4536 0H35.4537Z",
    fill: "#978284"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93652 26.6897V31.6553C1.93652 32.8078 2.39416 33.9127 3.20894 34.7276C4.02377 35.5424 5.12864 36 6.28124 36H31.1088C32.2613 36 33.3662 35.5424 34.1811 34.7276C34.996 33.9128 35.4535 32.8079 35.4535 31.6553V18.0001H31.7296V31.6553C31.7296 31.8198 31.6643 31.9778 31.5478 32.0943C31.4313 32.2108 31.2733 32.2761 31.1088 32.2761H25.5228V22.9658H21.7984V32.2761H15.5915V20.483H11.8672V32.2761H6.28118C5.93828 32.2761 5.66032 31.9982 5.66032 31.6553V26.6897L1.93652 26.6897Z",
    fill: "#978284"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.bc47433a4c048ed3c0589fe2a781957e.svg";
export { ForwardRef as ReactComponent };